import type { InteriorMaterial } from "building-types/materials/interiorPaletteTypes";
import type {
  CrownTrimMolding,
  BaseTrimMolding,
  InteriorWallPlaneTrimMolding,
} from "building-types/molding/trimMoldingTypes";
import type { RoomSet } from "building-types/rooms/roomTraversalTypes";
import uid from "common/utils/uid";
import { buildingEntityBaseNew } from "doc/utils/buildingEntityTools";
import type { BRep } from "geom/brep";
import type { PolyLine3 } from "geom/polyLine3";
import type { UVTransformation } from "geom/uv";

export function crownTrimMoldingNew(
  levelId: string,
  roomSet: RoomSet,
  trims: BRep[],
  material: InteriorMaterial,
  trimRails: PolyLine3[],
): CrownTrimMolding {
  return {
    ...buildingEntityBaseNew("INTERIOR_TRIM", uid()),
    subType: "CROWN",
    levelId,
    roomSet,
    trims,
    material,
    trimRails,
  };
}

export function baseTrimMoldingNew(
  levelId: string,
  roomSet: RoomSet,
  trims: BRep[],
  material: InteriorMaterial,
  trimRails: PolyLine3[],
): BaseTrimMolding {
  const instanceId = roomSet[0]?.instanceId;

  return {
    ...buildingEntityBaseNew("INTERIOR_TRIM", uid()),
    ...(instanceId
      ? {
          pickHandle: { type: "COMPONENT_INSTANCE", id: instanceId },
        }
      : {}),
    subType: "BASE",
    levelId,
    roomSet,
    trims,
    material,
    trimRails,
  };
}

export function interiorWallPlaneTrimMoldingNew({
  levelId,
  roomSet,
  trims,
  material,
  trimRails,
  sourceId,
  ruleId,
  planeHash,
  profileId,
  profileName,
  materialTransformation,
}: {
  readonly levelId: string;
  readonly roomSet: RoomSet;
  readonly trims: BRep[];
  readonly material: InteriorMaterial;
  readonly trimRails: PolyLine3[];
  readonly sourceId: string;
  readonly ruleId: string;
  readonly planeHash: string;
  readonly profileId: InteriorWallPlaneTrimMolding["profileId"];
  readonly profileName: string;
  readonly materialTransformation?: UVTransformation;
}): InteriorWallPlaneTrimMolding {
  return {
    ...buildingEntityBaseNew("INTERIOR_TRIM", uid()),
    subType: "WALL_PLANE",
    levelId,
    roomSet,
    trims,
    material,
    trimRails,
    sourceId,
    ruleId,
    planeHash,
    profileId,
    profileName,
    materialTransformation,
  };
}
